import React, { ReactNode } from 'react';
import { grey, lightBlue } from '@mui/material/colors';
import { Typography, Box, Stack } from '@mui/material';

interface Props {
  icon: ReactNode;
  label: ReactNode;
  amount: ReactNode;
}

export const SummaryCard = ({ amount, icon, label }: Props) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        padding: '1rem',
        borderRadius: '0.25rem',
        border: `1px solid ${grey[300]}`,
      }}
    >
      <Stack direction="row" justifyContent="space-between" width="100%">
        <Stack justifyContent="space-between">
          <Typography variant="subtitle1" fontWeight={500} component="span" color="textSecondary">
            {label}
          </Typography>

          <Typography variant="h6" component="span">
            {amount}
          </Typography>
        </Stack>

        <Box
          sx={{
            display: 'flex',
            padding: '0.25rem',
            alignItems: 'center',
            height: 'fit-content',
            borderRadius: '0.25rem',
            justifyContent: 'center',
            background: lightBlue[50],
            border: `1px solid ${lightBlue[100]}`,
          }}
        >
          {icon}
        </Box>
      </Stack>
    </Box>
  );
};
